module.exports = __webpack_public_path__ + "static/creator-tokens-fundraising-a1ebc1a610482d3ecdd44b4ee8f244f2.webp";